import React from 'react'
import {
  List,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Tooltip,
} from '@mui/material'
import { MenuJobsStatus, TMenuItems } from '../../../utils/types/layoutTypes'
import { MENU_JOBS_STATUS } from '../../../utils/initialisations/router'
import { useNavigate } from 'react-router-dom'
import { useNotificationCounterContext } from '../../../context/notificationsCounterContext/NotificationsCounterContextProvider'

type TJobsMenuListWithStatus = {
  index: number
  fullPath: string
  listItem: TMenuItems
}

const JobsMenuListWithStatus = ({
  index,
  fullPath,
  listItem,
}: TJobsMenuListWithStatus) => {
  const navigate = useNavigate()
  const { dashboardData } = useNotificationCounterContext()

  const getMenuItemCounter = (counterLabel: string) => {
    if (dashboardData) {
      const counter =
        dashboardData.summary[
          counterLabel as keyof typeof dashboardData.summary
        ]

      if (counter > 999) {
        return '999+'
      }

      return counter
    }

    return 0
  }

  return (
    <React.Fragment>
      <Tooltip title={listItem.label} placement="right">
        <ListItemButton
          key={`mj-${index}`}
          onClick={() => navigate(`${listItem.goToUrl}?status=all`)}
          sx={{ pb: 0 }}
        >
          <ListItemIcon sx={{ color: 'var(--white)', minWidth: '40px' }}>
            {listItem.icon}
          </ListItemIcon>
          <ListItemText primary={listItem.label} />
        </ListItemButton>
      </Tooltip>
      <List component="div" disablePadding>
        {MENU_JOBS_STATUS.map((item: MenuJobsStatus, idMain) => {
          return (
            <React.Fragment key={`mjs-${idMain}`}>
              <ListItemButton
                sx={{ pl: 3, mb: 0, pb: 0 }}
                onClick={() => navigate(item.goToUrl)}
              >
                <ListItemIcon sx={{ color: 'var(--white)', minWidth: '40px' }}>
                  {item.icon}
                </ListItemIcon>
                <ListItemText
                  primary={`${item.label} (${getMenuItemCounter(
                    item.counterLabel
                  )})`}
                />
              </ListItemButton>
              {item.subMenus && (
                <List component="div" disablePadding sx={{ pl: 4 }}>
                  {item.subMenus.map((subMenu, idSubMenu) => {
                    return (
                      <ListItemButton
                        key={`mjssm-${idMain}-${idSubMenu}`}
                        sx={{ pl: 2, pt: 0.2, pb: 0.2 }}
                        onClick={() => navigate(subMenu.goToUrl)}
                      >
                        <ListItemIcon
                          sx={{ color: 'var(--white)', minWidth: '40px' }}
                        >
                          {subMenu.icon}
                        </ListItemIcon>
                        <ListItemText
                          sx={{
                            '& .MuiListItemText-primary': {
                              fontSize: '14px',
                            },
                          }}
                          primary={`${subMenu.label} (${getMenuItemCounter(
                            subMenu.counterLabel
                          )})`}
                        />
                      </ListItemButton>
                    )
                  })}
                </List>
              )}
            </React.Fragment>
          )
        })}
      </List>
    </React.Fragment>
  )
}

export default JobsMenuListWithStatus
